import React from 'react';
import axios from 'axios';
import { Loading, ToastNotification } from 'carbon-components-react';
import { t } from '../../RI18n';
import './style.css';

class OutdatedDatabase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      backendData: {},
    };
  }

  componentDidMount() {
    axios
      .get('/sam/todo_list/outdated_database.json')
      .then((result) => {
        this.setState({
          isLoaded: true,
          backendData: result.data,
        });
      })
      .catch(() => {
        this.setState({
          isLoaded: true,
          error: true,
        });
      });
  }

  render() {
    const { error, isLoaded, backendData } = this.state;

    if (backendData.to_display === false) {
      return null;
    }

    if (error) {
      console.log(t('todolist.outdated_database.error'));
      return null;
    }
    if (!isLoaded) {
      return (
        <span>
          <br />
          <Loading small withOverlay={false} />
        </span>
      );
    }
    if (backendData.outdated_db !== false || backendData.outdated_os !== false) {
      if (this.props.notify) {
        this.props.updateToDos();
      }

      const flex = `db_${backendData.outdated_db !== false}_os_${backendData.outdated_os !== false}`;
      const flexWithAdmin = `${backendData.is_admin === true ? '' : 'not_'}admin_${flex}`;

      const renderedReportStatusText = t('widget.status.error');
      const titleText = t(`todolist.outdated_database.title_${flexWithAdmin}`,
        { db: t(`todolist.outdated_database.db_name_${backendData.outdated_db}`), os: t(`todolist.outdated_database.os_name_${backendData.outdated_os}`) });

      const titleTextWithTooltip = (
        <span
          className="notification_text"
          title={renderedReportStatusText}
        >
          {titleText}
        </span>
      );
      const subtitleText = (
        <span className="notification_text">
          <span
            dangerouslySetInnerHTML={{
              __html: t(`todolist.outdated_database.caption_${flexWithAdmin}`,
                { db: t(`todolist.outdated_database.db_name_${backendData.outdated_db}`), os: t(`todolist.outdated_database.os_name_${backendData.outdated_os}`) }),
            }}
          />
        </span>
      );

      const captionText = (
        <div
          className="notification_text"
          dangerouslySetInnerHTML={{
            __html: t('todolist.outdated_database.details',
              { url: `https://ibm.biz/LMT_upgrade_old_${(backendData.outdated_db === 'db2' || backendData.outdated_os === 'rhel') ? 'lin' : 'win'}` }),
          }}
        />
      );

      return (
        <ToastNotification
          className="notification_style"
          title={titleTextWithTooltip}
          subtitle={subtitleText}
          caption={captionText}
          hideCloseButton
          kind="error"
          aria-label={t('todolist.aria_label', {
            name: t(`todolist.outdated_database.name_${flex}`),
            status: renderedReportStatusText,
          })}
          role="region"
        />
      );
    }

    return null;
  }
}

export default OutdatedDatabase;
